export const COMPLETE_ONBOARDING = 'COMPLETE_ONBOARDING';
export const PAYMENT_IDENTIFIER = 'PAYMENT_IDENTIFIER';

export interface IOnboardingState {
    payload: boolean;
    identifier: string;
}

interface ISetOnboardingToComplete {
    type: typeof COMPLETE_ONBOARDING;
    payload: boolean;
}

interface ISetPaymentModel {
    type: typeof PAYMENT_IDENTIFIER;
    payload: string;
}

export type OnboardingActionTypes = ISetOnboardingToComplete | ISetPaymentModel;
